/* eslint-disable */
<template>
  <div class="specialist-menu sub-menu">
    <ul>
      <li :class="{'sub-menu-selected': indexProps === '0'}"><router-link to="/specialist-user-guides?index=0">Adding Extra Availability for bookings</router-link></li>
      <li :class="{'sub-menu-selected': indexProps === '1'}"><router-link to="/specialist-user-guides?index=1">Adding your dictation or report to a booking</router-link></li>
      <li :class="{'sub-menu-selected': indexProps === '2'}"><router-link to="/specialist-user-guides?index=2">Downloading your Schedules</router-link></li>
      <li :class="{'sub-menu-selected': indexProps === '3'}"><router-link to="/specialist-user-guides?index=3">Navigating Bookings, Downloading Files, and Viewing your calendar</router-link></li>
      <li :class="{'sub-menu-selected': indexProps === '4'}"><router-link to="/specialist-user-guides?index=4">Updating your Profile</router-link></li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'SpecialistMenu',
  props: ["indexProps"],
  data() {
    return {

    }
  },
  methods: {

  },
  beforeMount() {
    if(this.indexProps == undefined) {
      this.indexProps = 0
    }
  }
}
</script>
